import React, { useEffect, useState } from 'react';
import { Phone, ChevronLeft, ChevronRight } from 'lucide-react';
import { Card } from '../ui/Card';
import { mockInterviews } from '../../utils/mockData';
import { getMonthDays, getToday } from '../../utils/dateUtils';
export function PhoneScreenCalendarWidget() {
  const [currentDate, setCurrentDate] = useState(getToday());
  const [calendarDays, setCalendarDays] = useState<(Date | null)[]>([]);
  const [screenMap, setScreenMap] = useState<Record<number, number>>({});
  useEffect(() => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    setCalendarDays(getMonthDays(year, month));
    const counts: Record<number, number> = {};
    mockInterviews.forEach(interview => {
      if (interview.type !== 'Phone Screen' && interview.type !== 'Video Call') return;
      const interviewDate = new Date(interview.dateTime);
      if (interviewDate.getMonth() === month && interviewDate.getFullYear() === year) {
        const day = interviewDate.getDate();
        counts[day] = (counts[day] || 0) + 1;
      }
    });
    setScreenMap(counts);
  }, [currentDate]);
  const nextMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  const prevMonth = () => setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  const monthName = currentDate.toLocaleString('default', {
    month: 'long',
    year: 'numeric'
  });
  const today = getToday();
  return <Card title="Phone Screens" icon={<Phone className="h-4 w-4" data-id="element-1081" />} action={<div className="flex items-center gap-1" data-id="element-1082">
          <button onClick={prevMonth} className="p-1 hover:bg-orange-50 rounded-full transition-colors" data-id="element-1083">
            <ChevronLeft className="h-3.5 w-3.5 text-gray-600" data-id="element-1084" />
          </button>
          <span className="text-[11px] font-medium w-20 text-center text-gray-700" data-id="element-1085">
            {monthName}
          </span>
          <button onClick={nextMonth} className="p-1 hover:bg-orange-50 rounded-full transition-colors" data-id="element-1086">
            <ChevronRight className="h-3.5 w-3.5 text-gray-600" data-id="element-1087" />
          </button>
        </div>} data-id="element-1080">
      <div className="space-y-1.5" data-id="element-1088">
        <div className="grid grid-cols-7 gap-0.5 text-center" data-id="element-1089">
          {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((d, i) => <div key={`${d}-${i}`} className="text-[9px] font-medium text-gray-400 py-0.5" data-id="element-1090">
              {d}
            </div>)}
        </div>
        <div className="grid grid-cols-7 gap-0.5" data-id="element-1091">
          {calendarDays.map((date, idx) => {
          if (!date) return <div key={`empty-${idx}`} className="h-6" data-id="element-1092" />;
          const dayNum = date.getDate();
          const count = screenMap[dayNum];
          const isToday = date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
          return <div key={idx} className={`h-6 flex flex-col items-center justify-center rounded text-[10px] relative ${isToday ? 'bg-gradient-to-br from-orange-50 to-orange-100 text-orange-700 font-bold border border-orange-200 shadow-sm' : 'hover:bg-gray-50 text-gray-700'} ${count ? 'cursor-pointer' : ''}`} title={count ? `${count} phone screen${count > 1 ? 's' : ''}` : undefined} data-id="element-1093">
                <span data-id="element-1094">{dayNum}</span>
                {count > 0 && <div className="absolute bottom-0.5 h-0.5 w-0.5 rounded-full bg-orange-500" data-id="element-1095" />}
              </div>;
        })}
        </div>
      </div>
    </Card>;
}